module.exports = __webpack_public_path__ + "img/MilitaryTechBackgroundC03_ua.2f3a9638.webp";